module.exports = __webpack_public_path__ + "static/img/CX.1d7fd6a5.svg";